/* eslint-disable max-len */
export default {
  id: 'en',
  messages: {
    'dst.empty.title': 'Enter some keywords above to get started',
    'dst.empty.text': 'Search in the field above for a specific domain name, or enter keywords to start searching for your perfect domain.',
    'dst.search.basket': 'View my basket',
    'dst.searching.title': 'Searching\u2026',
    'dst.searching.text': 'We\'ll have your domain results in a moment!',
    'dst.noResults.title': 'We could not find any domains matching your search',
    'dst.noResultsHasExact.title': 'We could not find any other domains matching your search',
    'dst.noResults.text': 'Why not try reducing the number of filters, searching with keywords or double checking your spelling',
    'dst.error.title': 'Oh no! Looks like something went wrong :(',
    'dst.error.text': 'Probably nothing, give it another go\u2026',
    'dst.exactMatch.v2.notFound.text': 'Sorry, {domain} has already been registered.',
    'dst.exactMatch.v2.void.text': 'Sorry, {domain} is void.',
    'dst.exactMatch.v2.found.text': 'Yes! {domain} is available, get it now before it\'s too late!',
    'dst.exactMatch.v2.price': 'Only {price}',
    'dst.exactMatch.v2.oldPrice': '{price}',
    'dst.exactMatch.v2.promo.price': 'Now {price}',
    'dst.exactMatch.v2.buy': 'Add to basket',
    'dst.exactMatch.v2.verifying': 'Verifying\u2026',
    'dst.exactMatch.v2.available': 'Added',
    'dst.exactMatch.v2.unavailable': 'Sorry, not available',
    'dst.exactMatch.v2.basket': 'View basket',
    'dst.exactMatch.v2.backorder': 'Request a backorder',
    'dst.exactMatch.v2.transfer': 'Transfer my domain',
    'dst.exactMatch.v2.negotiate': 'Negotiate this domain',
    'dst.exactMatch.v2.promo': 'Sale!',

    'dst.exactMatch.v2.notFound.negotiateOrBackorderOrTransfer': 'If you already own this, you can transfer it to us, negotiate this domain, or you can request to backorder this domain.',
    'dst.exactMatch.v2.notFound.negotiateOrTransfer': 'If you already own this domain you can transfer it to us, or you can request to negotiate for this domain.',
    'dst.exactMatch.v2.notFound.negotiateOrBackorder': 'You can request to backorder this domain, or you can request to negotiate for this domain.',
    'dst.exactMatch.v2.notFound.transferOrBackorder': 'If you already own this, you can transfer it to us, or you can request to backorder this domain.',
    'dst.exactMatch.v2.notFound.transfer': 'If you already own this domain, you can transfer it to us',
    'dst.exactMatch.v2.notFound.backorder': 'You can request to backorder this domain.',
    'dst.exactMatch.v2.notFound.negotiate': 'You can request to have an agent negotiate the purchase of this domain for you.',

    // afternic updates
    'dst.exactMatch.v3.backorder': 'Request a backorder',
    'dst.exactMatch.v3.transfer': 'Transfer it to us',
    'dst.exactMatch.v3.notFound.transferOrBackorder': 'Own this domain? {transfer}. Want this domain? {backorder}.',
    'dst.exactMatch.v3.notFound.transfer': 'Own this? {transfer}.',
    'dst.exactMatch.v3.notFound.backorder': 'Interested? {backorder}.',
    'dst.exactMatch.v3.notFound.none': ' ',
    'dst.exactMatch.v3.notFound.negotiate.title': 'Still want this domain?',
    'dst.exactMatch.v3.notFound.negotiate.text': 'Let us help you get it',
    'dst.exactMatch.v3.notFound.negotiate.button': 'Get this domain',
    'dst.exactMatch.v3.verifying': 'Verifying\u2026',
    'dst.exactMatch.v3.available': 'Added',
    'dst.negotiate.v2.title': 'Let\'s help you get that domain\u2026',
    'dst.negotiate.v2.text': 'We\'ll contact the current owner on your behalf. If they are willing to sell the domain, we\'ll do all we can to get it for you!',
    'dst.negotiate.v2.showMore': 'Show me how it works',
    'dst.negotiate.v2.productName': 'Negotiation service',
    'dst.negotiate.v2.priceTerm': 'per domain{asterisk}',
    'dst.negotiate.v2.legalAsterisk': '*',
    'dst.negotiate.v2.legalText': '* Commission may be payable on the purchase of the domain',
    'dst.negotiate.v2.submit': 'Add to basket',
    'dst.negotiate.v2.success': 'Added',
    'dst.negotiate.v2.step1': 'First, we track down the current domain owner and initiate a negotiation on your behalf.',
    'dst.negotiate.v2.step2': 'Our agents will work with you to get your budget, and negotiate with the domain owner.',
    'dst.negotiate.v2.step3': 'Purchase the domain and we\'ll take care of transferring it into your account, ready to use.',
    'dst.negotiate.addedToBasket': '{fqdn} is almost yours',
    'dst.negotiate.checkout': 'Checkout',

    'dst.standardDomains.title': 'We\'ve found {count} { count, plural, one {domain} other {domains} } just for you\u2026',
    'dst.standardDomains.sale': 'Sale!',
    'dst.standardDomains.ad': 'Ad',
    'dst.standardDomains.domainTerm': 'All prices shown are for 1 year unless otherwise stated.',
    // 'dst.standardDomains.taxation': 'All prices exclude VAT at 20%.', // optional
    // 'dst.standardDomains.includesTax': 'All prices include VAT at {taxRate}%', // optional
    // 'dst.standardDomains.excludesTax': 'All prices exclude VAT at {taxRate}%', // optional
    'dst.standardDomains.price': 'First year {price}',
    'dst.standardDomains.oldPrice': '{price}',
    'dst.standardDomains.buy': 'Add to basket',
    'dst.standardDomains.transfer': 'Transfer my domain',
    'dst.standardDomains.backorder': 'Request a backorder',
    'dst.standardDomains.negotiate': 'Negotiate this domain',
    'dst.standardDomains.verifying': 'Verifying',
    'dst.standardDomains.available': 'In your {basketLink}',
    'dst.standardDomains.unavailable': 'Sorry, not available',
    'dst.standardDomains.basket': 'basket',
    'dst.filters.tlds.all': 'Show me all',
    'dst.filters.exactOnly': 'Only show exact matches',
    // bundles
    'dst.exactMatch.bundles.saving': 'Save {saving}',
    'dst.exactMatch.bundles.promo': 'Offer!',
    'dst.exactMatch.bundles.price': 'Only {price}',
    'dst.exactMatch.bundles.buy': 'Add to basket',
    'dst.exactMatch.bundles.verifying': 'Verifying\u2026',
    'dst.exactMatch.bundles.available': 'Added',
    'dst.exactMatch.bundles.basket': 'View basket',
    'dst.exactMatch.bundles.text': 'Owning additional domain extensions helps protect your brand. {link}',
    'dst.exactMatch.bundles.text.link': 'Learn more',

  },
};
/* eslint-enable max-len */
